import Home from "./Home.kr";

export default {
  ...Home
}



// WEBPACK FOOTER //
// ./src/lang/home/kr.js